import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  FarmerInsightsModuleState,
  NormalizedQueryableCycle,
  NormalizedQueryableLocation,
} from '../../models/farmer-insights.model';

export const getFarmerInsightsModuleState =
  createFeatureSelector<FarmerInsightsModuleState>('farmerInsightsModule');

export const getTimeSeries = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.timeSeries,
);

export const getBenchmarkTimeSeries = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.benchmarkTimeSeries,
);

export const getBenchmarkSelectedPeriodData = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.benchmarkSelectedPeriodData,
);
export const getBenchmarkLastWeeksData = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.benchmarkLastWeeksData,
);
export const getBenchmarkCustomerAveragSelectedPeriodData = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.benchmarkCustomerAverageSelectedPeriodData,
);

export const getQueryableFlockData = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.queryableFlockData,
);

export const getNormalizedQueryableLocations = createSelector(
  getFarmerInsightsModuleState,
  (state) =>
    state.queryableFlockData !== null
      ? state.queryableFlockData.locations.map((l) => {
          const location: NormalizedQueryableLocation = {
            ...l,
            cycles: l.cycleIds.map((cycleId) => {
              const existingCycle = state.queryableFlockData.cycles.find(
                (d) => d.cycleId === cycleId,
              );
              const cycle: NormalizedQueryableCycle = {
                ...existingCycle,
                barns: existingCycle.barnIds.map((barnId) =>
                  state.queryableFlockData.barns.find((d) => d.barnId === barnId),
                ),
              };
              return cycle;
            }),
          };
          return location;
        })
      : [],
);

export const getNormalizedTimeSeriesArray = createSelector(getFarmerInsightsModuleState, (state) =>
  state.normalizedTimeSeriesArray.filter((ts) => !!ts.locationId),
);

export const getNormalizedTimeSeriesWithTotalsArray = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.normalizedTimeSeriesArray,
);

export const getSelectedKpis = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedKpis,
);

export const getIsDetailedModeSelected = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.isDetailedModeSelected,
);

export const getSelectedViewMode = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedViewMode,
);

export const getSelectedLocations = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedLocationIds,
);

export const getUnselectedCycleIds = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.unselectedCycleIds,
);

export const getSelectedBarnIds = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedBarnIds,
);

export const getSelectedDataViewType = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedDataViewType,
);

export const getSelectedDateRange = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedDateRange,
);

export const getSelectedConceptId = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.selectedConceptId,
);

export const getBenchmarkSettings = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.benchmarkSettings,
);

export const getLocalFilterSettings = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.localFilterSettings,
);

export const getGlobalFilterSettings = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.globalFilterSettings,
);

export const getKpiGroups = createSelector(
  getFarmerInsightsModuleState,
  (state) => state.kpiGroups,
);
